import FlightRotations from './FlightRotations'

export default FlightRotations